export const blockFViewMapper = {
  "H1.00.01": "H1.00.01",
  "H1.01.01": ["H1.01.01", "H1.01.01_Copy"],
  "H1.01.02": "H1.01.02",
  "H1.01.03": "H1.01.03",
  "H1.02.01": "H1.02.01",
  "H1.02.02": ["H1.02.02", "H1.02.02_Copy"],
  "H1.02.03": "H1.02.03",
  "H1.02.04": ["H1.02.04", "H1.02.04_Copy"],
  "H1.03.01": "H1.03.01",
  "H1.03.02": ["H1.03.02", "H1.03.02_Copy"],
  "H1.03.03": "H1.03.03",
  "H1.03.04": ["H1.03.04", "H1.03.04_Copy"],
  "H1.04.01": "H1.04.01",
  "H1.04.02": ["H1.04.02", "H1.04.02_Copy"],
  "H1.04.03": "H1.04.03",
  "H1.04.04": ["H1.04.04", "H1.04.04_Copy"],
  "H1.05.01": "H1.05.01",
  "H1.05.02": ["H1.05.02", "H1.05.02_Copy"],
  "H1.05.03": "H1.05.03",
  "H1.05.04": ["H1.05.04", "H1.05.04_Copy"],
  "H1.06.01": "H1.06.01",
  "H1.06.02": "H1.06.02",
  "H1.06.03": "H1.06.03",
  "H1.06.04": ["H1.06.04", "H1.06.04_Copy"],
  "H3.00.01": "H3.00.01",
  "H3.00.02": "H3.00.02",
  "H3.01.01": "H3.01.01",
  "H3.01.02": "H3.01.02",
  "H3.01.03": "H3.01.03",
  "H3.02.01": ["H3.02.01", "H3.02.01_Copy"],
  "H3.02.02": "H3.02.02",
  "H3.02.03": ["H3.02.03", "H3.02.03_Copy"],
  "H3.03.01": ["H3.03.01", "H3.03.01_Copy"],
  "H3.03.02": "H3.03.02",
  "H3.03.03": ["H3.03.03", "H3.03.03_Copy"],
  "H3.04.01": ["H3.04.01", "H3.04.01_Copy"],
  "H3.04.02": "H3.04.02",
  "H3.04.03": ["H3.04.03", "H3.04.03_Copy"],
  "H3.05.01": ["H3.05.01", "H3.05.01_Copy"],
  "H3.05.02": "H3.05.02",
  "H3.05.03": ["H3.05.03", "H3.05.03_Copy"],
  "H3.06.01": ["H3.06.01", "H3.06.01_Copy"],
  "H3.06.02": ["H3.06.02", "H3.06.02_Copy"],
  "H3.07.01": ["H3.07.01", "H3.07.01_Copy"],
  "H3.07.02": ["H3.07.02", "H3.07.02_Copy"],
  "H4.00.01": "H4.00.01",
  "H4.00.02": "H4.00.02",
  "H4.01.01": "H4.01.01",
  "H4.01.02": "H4.01.02",
  "H4.01.03": "H4.01.03",
  "H4.02.01": ["H4.02.01", "H4.02.01_Copy"],
  "H4.02.02": "H4.02.02",
  "H4.02.03": ["H4.02.03", "H4.02.03_Copy"],
  "H4.03.01": ["H4.03.01", "H4.03.01_Copy"],
  "H4.03.02": "H4.03.02",
  "H4.03.03": ["H4.03.03", "H4.03.03_Copy"],
  "H4.04.01": ["H4.04.01", "H4.04.01_Copy"],
  "H4.04.02": "H4.04.02",
  "H4.04.03": ["H4.04.03", "H4.04.03_Copy"],
  "H4.05.01": ["H4.05.01", "H4.05.01_Copy"],
  "H4.05.02": "H4.05.02",
  "H4.05.03": ["H4.05.03", "H4.05.03_Copy"],
  "H4.06.01": ["H4.06.01", "H4.06.01_Copy"],
  "H4.06.02": "H4.06.02",
  "H4.07.01": ["H4.07.01", "H4.07.01_Copy"],
  "H5.00.01": "H5.00.01",
  "H5.00.02": "H5.00.02",
  "H5.00.03": "H5.00.03",
  "H5.01.01": "H5.01.01",
  "H5.01.02": "H5.01.02",
  "H5.01.03": "H5.01.03",
  "H5.01.04": "H5.01.04",
  "H5.02.01": ["H5.02.01", "H5.02.01_Copy"],
  "H5.02.02": "H5.02.02",
  "H5.02.03": ["H5.02.03", "H5.02.03_Copy"],
  "H5.02.04": "H5.02.04",
  "H5.03.01": ["H5.03.01", "H5.03.01_Copy"],
  "H5.03.02": "H5.03.02",
  "H5.03.03": ["H5.03.03", "H5.03.03_Copy"],
  "H5.03.04": "H5.03.04",
  "H5.04.01": "H5.04.01",
  "H5.04.02": ["H5.04.02", "H5.04.02_Copy"],
  "H5.04.03": ["H5.04.03", "H5.04.03_Copy"],
  "H5.05.01": "H5.05.01",
  "H5.05.02": ["H5.05.02", "H5.05.02_Copy"],
  "H5.05.03": ["H5.05.03", "H5.05.03_Copy"],
  "H6.01.01": ["H6.01.01", "H6.01.01_Copy"],
  "H6.01.02": "H6.01.02",
  "H6.01.03": ["H6.01.03", "H6.01.03_Copy"],
  "H6.02.01": ["H6.02.01", "H6.02.01_Copy"],
  "H6.02.02": "H6.02.02",
  "H6.02.03": ["H6.02.03", "H6.02.03_Copy"],
  "H6.03.01": ["H6.03.01", "H6.03.01_Copy"],
  "H6.03.02": "H6.03.02",
  "H6.03.03": ["H6.03.03", "H6.03.03_Copy"],
  "H7.00.01": "H7.00.01",
  "H7.00.02": "H7.00.02",
  "H7.01.01": ["H7.01.01", "H7.01.01_Copy"],
  "H7.01.02": "H7.01.02",
  "H7.01.03": "H7.01.03",
  "H7.01.04": ["H7.01.04", "H7.01.04_Copy"],
  "H7.02.01": "H7.02.01",
  "H7.02.02": "H7.02.02",
  "H7.02.03": ["H7.02.03", "H7.02.03_Copy"],
  "H7.02.04": "H7.02.04",
  "H7.03.01": "H7.03.01",
  "H7.03.02": ["H7.03.02", "H7.03.02_Copy"],
  "H7.03.03": ["H7.03.03", "H7.03.03_Copy"],
  "H7.03.04": "H7.03.04",
  "H7.04.01": "H7.04.01",
  "H7.04.02": ["H7.04.02", "H7.04.02_Copy"],
  "H7.04.03": "H7.04.03",
  "H7.05.01": ["H7.05.01", "H7.05.01_Copy"],

  "F1.02.01": "360_Camera_00",
  "F1.02.02": "360_Camera_01",
  "F1.08.01": "360_Camera_02",
  "F1.07.01": "360_Camera_03",
  "F1.07.02": "360_Camera_04",
  "F1.06.01": "360_Camera_05",
  "F1.06.02": "360_Camera_06",
  "F2.02.08": "360_Camera_07",
  "F2.02.07": "360_Camera_08",
  "F1.05.01": "360_Camera_09",
  "F1.05.02": "360_Camera_10",
  "F1.03.02": "360_Camera_11",
  "F1.03.01": "360_Camera_12",
  "F2.08.02": "360_Camera_13",
  "F2.08.03": "360_Camera_14",
  "F2.07.02": ["360_Camera_15", "360_Camera_115"],
  "F2.07.03": ["360_Camera_16", "360_Camera_114"],
  "F2.06.04": "360_Camera_17",
  "F2.03.07": "360_Camera_18",
  "F2.03.06": "360_Camera_19",
  "F2.06.05": "360_Camera_20",
  "F2.05.04": "360_Camera_21",
  "F1.04.02": "360_Camera_22",
  "F1.04.01": "360_Camera_23",
  "F2.05.05": "360_Camera_24",
  "F2.04.06": "360_Camera_25",
  "F2.04.07": "360_Camera_26",
  "F1.08.02": "360_Camera_27",
  "F2.04.08": "360_Camera_28",
  "F1.04.06": "360_Camera_29",
  "F1.04.08": "360_Camera_30",
  "F2.04.05": "360_Camera_31",
  "F2.05.07": ["360_Camera_33", "360_Camera_90"],
  "F1.05.06": "360_Camera_34",
  "F1.06.07": "360_Camera_35",
  "F1.07.06": "360_Camera_36",
  "F1.08.05": ["360_Camera_37", "360_Camera_112"],
  "F1.06.06": "360_Camera_38",
  "F2.06.06": "360_Camera_39",
  "F1.04.07": "360_Camera_40",
  "F2.03.05": "360_Camera_42",
  "F2.03.08": "360_Camera_43",
  "F2.03.01": ["360_Camera_44", "360_Camera_86"],
  "F1.03.07": "360_Camera_45",
  "F1.03.06": "360_Camera_46",
  "F1.03.08": "360_Camera_47",
  "F2.05.03": ["360_Camera_48", "360_Camera_100"],
  "F2.02.06": "360_Camera_51",
  "F2.02.01": "360_Camera_52",
  "F2.02.02": ["360_Camera_53", "360_Camera_95"],
  "F1.02.06": "360_Camera_54",
  "F1.02.07": "360_Camera_55",
  "F2.04.01": ["360_Camera_57", "360_Camera_88"],
  "F1.05.07": ["360_Camera_58", "360_Camera_106"],
  "F1.05.08": "360_Camera_59",
  "F2.05.06": "360_Camera_60",
  "F1.08.04": "360_Camera_62A",
  "F1.01.03": "360_Camera_63",
  "F1.01.01": "360_Camera_64",
  "F1.01.02": "360_Camera_65",
  "F2.01.01": "360_Camera_66",
  "F2.01.02": "360_Camera_67",
  "F2.01.03": "360_Camera_68",
  "F2.06.02": "360_Camera_69",
  "F2.02.04": "360_Camera_70",
  "F2.05.02": "360_Camera_71",
  "F1.02.05": "360_Camera_72",
  "F1.02.04": "360_Camera_73",
  "F2.04.03": "360_Camera_74",
  "F2.03.03": "360_Camera_75",
  "F1.03.05": "360_Camera_76",
  "F1.07.04": "360_Camera_77",
  "F1.06.04": "360_Camera_78",
  "F1.05.04": "360_Camera_79",
  "F1.03.04": "360_Camera_80",
  "F1.04.04": "360_Camera_81",
  "F2.08.01": "360_Camera_82",
  "F1.07.03": "360_Camera_83",
  "F1.06.03": "360_Camera_84",
  "F1.02.03": "360_Camera_85",
  "F1.05.03": "360_Camera_87",
  "F1.04.05": "360_Camera_89",
  "F2.06.01": "360_Camera_91",
  "F1.06.05": "360_Camera_92",
  "F1.04.03": "360_Camera_93",
  "F1.03.03": "360_Camera_94",
  "F1.08.03": "360_Camera_97",
  "F2.02.05": "360_Camera_101",
  "F2.03.04": "360_Camera_102",
  "F2.04.04": "360_Camera_103",
  "F2.05.01": "360_Camera_105",
  "F1.05.05": "360_Camera_107",
  "F2.02.03": "360_Camera_108",
  "F2.03.02": "360_Camera_109",
  "F2.04.02": "360_Camera_110",
  "F1.07.05": "360_Camera_113",
  "F2.07.01": "360_Camera_115",
  "F2.06.03": "360_Camera_49"
}
